import { useEffect, useState } from 'react';
import React from 'react';
import { API_DELETE, API_GET, DBRequest, useConfig } from '../api/api';
import {
  Alert,
  Badge,
  Box,
  Button,
  IconButton,
  Link,
  Popover,
  Typography,
} from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const Notifications = ({ debug = false }) => {
  const [notifications, setNotifications] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const config = useConfig();
  useEffect(() => {
    if (!config) return;
    updateNoteData();
    const noteUpdateInterval = setInterval(
      () => {
        updateNoteData();
      },
      1 * 60 * 1000,
    );
    return () => clearInterval(noteUpdateInterval);
  }, [config]);

  function updateNoteData() {
    DBRequest({
      config,
      path: 'notifications',
      method: API_GET,
      onResponse: handleResponse,
      onLoading: setIsLoading,
      disableRetry: true,
    });
  }

  function handleResponse(data) {
    const newNotificationLength = data?.data?.length;
    const oldNotificationsLength = notifications?.data?.length;
    setNotifications(data);
    if (newNotificationLength > oldNotificationsLength) {
      const newNote = data.data[newNotificationLength - 1];

      pushNotification(newNote.data.title, newNote.data.message);
    }
  }

  function handleDelete(id) {
    DBRequest({ config, path: `notifications/${id}`, method: API_DELETE });

    // update data array
    var newArray = [];
    notifications.data.forEach((note, index) => {
      if (note.id !== id) newArray.push({ ...note });
    });
    setNotifications({ ...notifications, data: newArray });
    if (newArray.length < 1) handleClose();
  }

  // Popover
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (debug) {
      pushNotification(
        'debug notification',
        'you can disable the notification with the boolean for debug',
      );
    }
    if (notifications.data && notifications.data.length < 1) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'notivication-popover' : undefined;

  const pushNotification = async (title, content) => {
    const audio = new Audio('/assets/sounds/notification.wav');
    audio.play();

    if (!('Notification' in window)) {
      return;
    }

    if (Notification.permission === 'granted') {
      showNotification(title, content);
    } else if (Notification.permission !== 'denied') {
      const permission = await window.Notification.requestPermission();
      if (permission === 'granted') {
        showNotification(title, content);
      }
    }
  };

  const showNotification = (title, content) => {
    new Notification(title, {
      body: content,
      icon: '/favicon.png',
      badge: '/favicon.png',
    });
  };

  return (
    <>
      {/*      <Button
        color="warning"
        onClick={() => pushNotification('test', 'bla bla bla')}
      >
        debug
      </Button>*/}
      <Badge
        color="warning"
        className=" cursor-pointer"
        onClick={handleClick}
        badgeContent={notifications.data ? notifications.data.length : 0}
        invisible={notifications.data ? !notifications.data.length : true}
        sx={{
          '& .MuiBadge-badge': {
            right: 7,
            top: 10,
          },
        }}
      >
        <IconButton aria-describedby={id} onClick={handleClick}>
          {<NotificationsOutlinedIcon />}
        </IconButton>
      </Badge>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <NotificationList
          onClose={handleClose}
          notifications={notifications}
          isLoading={isLoading}
          onDelete={handleDelete}
        />
      </Popover>
    </>
  );
};

const NotificationList = ({ notifications, isLoading, onDelete, onClose }) => {
  return (
    <Box
      className="flex flex-col gap-2 overflow-y-auto p-3"
      sx={{ maxHeight: 'calc(100vh - 53px - 30px)' }}
    >
      {!isLoading && (
        <>
          {notifications.data.map((element, index) => (
            <NotificationElement
              key={'Notification-' + index}
              element={element}
              onDelete={onDelete}
              onClose={onClose}
            />
          ))}
        </>
      )}
    </Box>
  );
};

const NotificationElement = ({ element, onDelete, onClose }) => {
  const navigate = useNavigate();
  const handleDeleteNotification = () => {
    onDelete(element.id);
  };

  function handleRedirect() {
    navigate(element.data.targetUrl);
    onDelete(element.id);
    onClose();
  }

  return (
    <Alert
      severity={element.data.type}
      className=" max-w-md"
      sx={{
        width: '500px',
        maxWidth: '100%',
        borderRadius: '10px',
        '& .MuiAlert-message': {
          width: '100%',
        },
        '& .MuiAlert-icon': {
          display: 'flex',
          alignItems: 'center',
        },
      }}
    >
      <Box className="flex w-full justify-between items-center gap-4">
        <Box className="flex flex-col items-start">
          <Typography variant="h5" color="i">
            <b>{element.data.title}</b>
          </Typography>
          <Typography variant="p">{element.data.message}</Typography>
          {element?.data?.targetUrl && (
            <Button onClick={handleRedirect}>{t('show')}</Button>
          )}
        </Box>
        <IconButton className=" float-right" onClick={handleDeleteNotification}>
          {<CloseOutlinedIcon />}
        </IconButton>
      </Box>
    </Alert>
  );
};

export default Notifications;
